import { type InjectionKey, inject, provide, type Ref, ref } from "vue";

const MANDATE_EDITOR_AVAILABLE: InjectionKey<Ref<boolean>> = Symbol(
  "mandateEditorAvailable"
);

/**
 * Lets a page say whether its mandate links may open the mandate editor; while they may not, each
 * `MandateLinkComponent` below it shows the mandate's name alone.
 */
export const provideMandateEditorAvailable = (available: Ref<boolean>) =>
  provide(MANDATE_EDITOR_AVAILABLE, available);

/** Whether mandate links open the mandate editor here; true on any page that does not say otherwise. */
export const useMandateEditorAvailable = (): Ref<boolean> =>
  inject(MANDATE_EDITOR_AVAILABLE, ref(true));
